/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var Send = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props),
        React.createElement("path", { d: "m1.5 4.15411601v10.34588399h15v-10.34588399l-7.15802944 6.71065259c-.19232909.1803085-.49161203.1803085-.68394112 0zm15.9425372-1.38705742c.017505.03318704.0313862.06858193.0411171.10565812.0141057.05273691.0198622.10779134.0163457.16282662v11.96445667c0 .2761424-.2238576.5-.5.5h-16c-.27614237 0-.5-.2238576-.5-.5v-11.96445667c-.00351652-.05503528.00224004-.11008971.01634565-.16282662.00973091-.03707619.02361214-.07247108.04111717-.10565812.07997078-.15328828.23727081-.26705859.44253718-.26705859h16c.2052664 0 .3625664.11377031.4425372.26705859zm-15.17814679.73294141 6.73560959 6.31463399 6.7356096-6.31463399z", fill: "#3d3d36" })));
};
export default Send;
